import React from 'react';
import bannerImage from '../../assets/brand/banner.png';

const CareersCTA: React.FC = () => {
  return (
    <section className="bg-white py-14">
      <div className="layout-container max-w-[1360px] mx-auto px-5">
        <div className="relative w-full min-h-[260px] bg-[#2776EA] rounded-[24px] overflow-hidden flex flex-col lg:flex-row items-center">
          <div className="absolute right-[-10%] top-[-70%] w-[640px] h-[640px] rounded-full border border-white opacity-100 pointer-events-none" />
          <div className="absolute right-[-12%] top-[-85%] w-[640px] h-[640px] rounded-full border border-white opacity-40 pointer-events-none" />

          <div className="relative z-10 lg:w-[60%] px-6 md:pl-10 py-10 flex flex-col items-start gap-6">
            <div className="flex flex-col gap-2 w-full">
              <h2 className="font-title text-[28px] md:text-[34px] font-semibold leading-[1.1] text-white max-w-[520px]">
                Interested in building your career at Bao Technologie ?
              </h2>
              <p className="font-description text-[13px] md:text-[14px] font-light text-[#E9F1FD] max-w-[520px] leading-[1.5]">
                Opportunities open up all the time. Stay in the loop and be the first to know when a role that matches you becomes available.
              </p>
            </div>

            <button className="bg-white/20 px-5 py-2.5 rounded-full flex items-center justify-center gap-2 hover:bg-white/30 transition-colors group">
              <span className="text-[14px] font-medium font-title text-white">Create a Job Alert</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="group-hover:translate-x-1 transition-transform">
                <path d="M5 12h14m-7-7 7 7-7 7" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
          </div>

          <div className="relative lg:absolute right-[-5%] top-[-4%] lg:w-[420px] lg:h-[300px] w-full h-[180px] mt-4 lg:mt-0 mix-blend-hard-light pointer-events-none overflow-hidden">
            <img
              src={bannerImage}
              alt="Professional collaboration"
              className="absolute inset-0 w-full h-full object-cover object-left-top lg:object-center"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareersCTA;
